<template>
  <div class="content-body">
    <LanguageSelector />
    <section id="basic-datatable">
      <div class="row">
        <div class="col-12">
          <div class="text-right">
            <button type="button" class="btn btn-primary mb-1 " @click="inviteAdminModal()">
              <em class="bx bx-envelope"></em>
              <span class="align-middle ml-25">{{ $t('users_module_button_invite_users') }}</span>
            </button>
          </div>
          <div class="card">
            <div class="card-content">
              <div class="card-header">
                <h5 class="card-title">{{ $t('users_module_heading_users') }}</h5>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">


                    <li class="listSize">
                      <div>
                        <select class="form-control mr-1" v-model="statusFilter" @change="filterByStatus(statusFilter)">
                          <option selected>{{ $t('users_module_filter_select_status') }}</option>
                          <option value="joined"> {{ $t('users_module_filter_active_status') }} </option>
                          <option value="banned"> {{ $t('users_module_filter_inactive_status') }} </option>
                          <option value="invited"> {{ $t('users_module_filter_invite_status') }} </option>
                        </select>
                      </div>
                    </li>
                    <li class="listSize">
                      <div class="has-icon-left">
                        <select class="form-control mr-1" v-model="countryFilter"
                          @change="filterByCountry(countryFilter)">
                          <option selected>{{ $t('users_module_filter_select_country') }}</option>
                          <option v-for="(country, index) in usersCountries" :value="country" :key="index">{{
                            countryName(country)
                          }}</option>
                        </select>
                        <div class="form-control-position">
                          <em class="bx bx-map font-medium-1"></em>
                        </div>
                      </div>
                    </li>
                    <li class="listSize">
                      <div class="has-icon-left">
                        <select class="form-control mr-1" v-model="searchFilter" @change="findByEmailModal()">
                          <option selected disabled value="default">{{ $t('users_module_search_search_by') }}</option>
                          <option value="all"> {{ $t('users_module_search_all_users') }}</option>
                          <option value="email"> {{ $t('users_module_search_search_by_email') }} </option>
                        </select>
                        <div class="form-control-position">
                          <em class="bx bx-search font-medium-1"></em>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body card-dashboard">
                <div class="text-center">
                  <div class="spinner-border text-primary" role="status" v-if="loadingData" style="opacity: .6">
                    <span class="sr-only">{{ $t('common_module_loader_label') }}</span>
                  </div>
                </div>
                <div class="text-center mt-1" v-if="!admins.length && !loadingData">
                  <p>{{ $t('common_module_label_users_not_found') }}</p>
                </div>
                <div class="table-responsive" v-if="admins.length">
                  <table class="table zero-configuration" :aria-label="$t('users_aria_label_admin_list')">
                    <thead>
                      <tr>
                        <th>{{ $t('common_module_datatable_heading_name') }}</th>
                        <th>{{ $t('common_module_datatable_heading_role') }}</th>
                        <th>{{ $t('common_module_datatable_heading_email') }}</th>
                        <th>{{ $t('common_module_datatable_heading_status') }}</th>
                        <th>{{ $t('common_module_datatable_heading_country') }}</th>
                        <th>{{ $t('common_module_datatable_heading_language') }}</th>
                        <th>{{ $t('common_module_datatable_heading_phone_number') }}</th>
                        <th>{{ $t('common_module_datatable_heading_actions') }}</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(admin, index) in admins" :key="index">
                        <td class="adminName">
                          <span class="nameSpan " v-if="admin.name">{{ admin.name }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td class="capitalize">{{ admin.type }}</td>
                        <td>
                          <span v-if="admin.email">{{ admin.email }}</span>
                          <span v-else>-</span>
                        </td>
                        <td class="capitalize">
                          <span v-if="admin.status == 'joined'">
                            <em class="bx bxs-circle success font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_active_status') }}</span>
                          </span>
                          <span v-else-if="admin.status == 'invited'">
                            <em class="bx bxs-circle info font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_invite_status') }}</span>
                          </span>
                          <span v-else>
                            <em class="bx bxs-circle danger font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_inactive_status') }}</span>
                          </span>
                        </td>
                        <td v-if="admin.country">{{ countryName(admin.country) }}</td>
                        <td v-else>-</td>
                        <td v-if="admin.language">{{ langName(admin.language) }}</td>
                        <td v-else>-</td>
                        <td v-if="admin.phoneNumber"> {{ admin.phoneNumber }}</td>
                        <td v-else>-</td>
                        <td>
                          <img v-if="admin.status != 'invited'" :src="editImage" alt="Edit Image"
                            class="iconEditStyle mr-1 cursor-pointer" @click="editAdminModal(admin.id)" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--      Find by Email Modal-->
    <div class="modal fade text-left" id="find-by-email-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modalStyle" v-if="searchFilter == 'email'">
          <div class="modal-header">
            <h3 class="modal-title " id="create-modal-title" v-if="searchFilter == 'email'">{{
              $t('users_module_search_popup_heading_search_by_email')
            }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close" @click="closeModal()">
              <em class="bx bx-x" ></em>
            </button>
          </div>
          <div class="modal-body">
            <Alert :text="$t('pacto_users_module_validation_email_error')" type="danger" dismbissable="false"
              v-if="emailError" />
            <form>
              <div class="form-group row" v-if="searchFilter == 'email'">
                <div class="col-md-12 col-sm-12">
                  <label>{{ $t('users_module_search_popup_label_email') }}</label>
                  <input type="email" class="form-control searchInput"
                    :placeholder="$t('users_module_search_popup_placeholder_email')" v-model="emailSearch"
                    @keyup="emailSearchValidation" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modalFooter" v-if="searchFilter == 'email'">

            <button type="button" class="btn btn-light-secondary" data-dismiss="modal" aria-label="Close" @click="closeModal()"
              v-if="searchFilter == 'email'">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block " style="color: white"
                v-if="searchFilter == 'email'">{{
                  $t('users_module_search_popup_search_by_email_cancel_button')
                }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal" aria-label="Close"
              @click="closeModal()">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block" @click="findByEmail()" v-if="searchFilter == 'email'">{{
                $t('users_module_search_popup_search_by_email_search_button')
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Invite Admin Modal -->
    <div class="modal fade text-left" id="invite-admin-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modalStyle">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">{{ $t('users_module_invite_popup_heading') }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close"
              @click="inviteModalClose()">
              <img :src="closeImage" alt="Close Image" />
            </button>
          </div>
          <div class="modal-body ">
            <Alert :text="inviteErrorText" type="danger" dismissable="false" v-if="inviteErrorText != ''" />
            <Alert :text="$t('users_module_invite_popup_required_alert')" type="danger" dismbissable="false"
              v-if="requiredError" />
            <Alert :text="$t('pacto_users_module_validation_email_error')" type="danger" dismbissable="false"
              v-if="emailSearchError" />
            <Alert :text="$t('pacto_users_module_validation_firstname_error')" type="danger" dismbissable="false"
              v-if="firstNameError" />
            <Alert :text="$t('pacto_users_module_validation_lastname_error')" type="danger" dismbissable="false"
              v-if="lastNameError" />
            <Alert :text="$t('pacto_users_module_validation_phone_error')" type="danger" dismbissable="false"
              v-if="invitePhoneError" />
            <Alert :text="$t('pacto_users_module_validation_type_error')" type="danger" dismbissable="false"
              v-if="typeInviteError" />
            <Alert :text="$t('pacto_users_module_validation_language_error')" type="danger" dismbissable="false"
              v-if="languageInviteError" />
            <Alert :text="$t('pacto_users_module_validation_country_error')" type="danger" dismbissable="false"
              v-if="countryInviteError" />

            <form action="#">
              <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('users_module_invite_popup_label_firstname') }}</label>
                  <input type="text" class="form-control"
                    :placeholder="$t('users_module_invite_popup_firstname_placeholder')" v-model="firstNameInvite" />
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('users_module_invite_popup_label_lastname') }}</label>
                  <input type="text" class="form-control"
                    :placeholder="$t('users_module_invite_popup_placeholder_lastname')" v-model="lastNameInvite" />
                </div>
              </div>

              <div class="form-group row ">
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('users_module_invite_popup_label_email') }}</label>
                  <input type="text" class="form-control"
                    :placeholder="$t('users_module_invite_popup_placeholder_email')" v-model="emailInvite" />
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('users_module_invite_popup_label_phone') }}</label>
                  <input type="tel" id="phoneNumber" class="form-control alignmentFix" v-model="invitePhoneNumber" />
                </div>
              </div>
              <div class="form-group row ">
                <div class="col-md-6 col-sm-12">


                  <label for>{{ $t('users_module_invite_dropdown_role') }}</label>
                  <select class="form-control" v-model="typeInvite">
                    <option selected value="default">{{ $t('users_module_invite_popup_dropdown_select_user_role') }}
                    </option>
                    <option value="superadmin">{{ $t('users_module_invite_popup_dropdown_super_admin') }} </option>
                    <option value="regionaladmin">{{ $t('users_module_invite_popup_dropdown_regional_admin') }}
                    </option>
                    <option value="countryadmin">{{ $t('users_module_invite_popup_dropdown_country_admin') }} </option>
                    <option value="pactousersuccesslead">{{
                      $t('users_module_invite_popup_dropdown_user_success_lead')
                    }} </option>
                  </select>
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('users_module_invite_popup_label_language') }}</label>
                  <select class="form-control " v-model="languageInvite">
                    <option selected value="default"> {{ $t('default_language_users') }} </option>
                    <option selected value="en"> {{ $t('en_language_users') }} </option>
                    <option value="ar"> {{ $t('ar_language_users') }} </option>
                    <option value="es"> {{ $t('es_language_users') }} </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('users_module_invite_popup_label_country') }}</label>
                  <select class="form-control mr-1" v-model="countryInvite">
                    <option selected value="default">{{ $t('users_module_invite_popup_dropdown_select_country') }}
                    </option>
                    <option v-for="(country, index) in usersCountries" :value="country" :key="index">{{
                      countryName(country)
                    }}</option>
                  </select>
                </div>
                <div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer footerClass">
            <button type="button" class="btn btn-light-secondary" data-dismiss="modal" @click="inviteModalClose">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('users_module_invite_popup_close_button') }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" @click="sendInvitation()">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('users_module_invite_popup_invitation_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--    Invite Successfull modal-->
    <div class="modal fade text-left" id="invite-success-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg modalPopStyle" role="document">
        <div class="modal-content resetPasswordDialogue">
          <div class="modal-header">
            <h3 class="modal-title resetPasswordHeading" id="create-modal-title">{{
              $t('users_module_invite_success_popup_heading')
            }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <img :src="closeImage" alt="Close image" />
            </button>
          </div>
          <div class="modal-body">

            <h3 class="modal-title resetPasswordSuccessHeading divStyleModall" id="create-modal-title">{{
              $t('users_module_success_invitation_popup_message')
            }}</h3>
          </div>
          <div class="modal-footer modalFooter">

            <button type="button" class="btn btn-light-secondary" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block " style="color: white">{{
                $t('users_module_invitation_success_popup_cancel_button')
              }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('users_module_invitation_success_popup_ok_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import { getCountryName } from "@/app-assets/js/get-countries.js";
import { getLanguageName } from "@/app-assets/js/get-language.js";
import Alert from "@/components/Alerts";
export default {
  data() {
    return {
      admins: [],
      usersCountries: [],
      countryFilter: "Select Country",
      statusFilter: "Select Status",
      typeFilter: "Select Type",
      activeCountries: [],
      loadingData: true,
      searchInputText: "",
      phoneNumberObj: null,
      phoneNumber: "",
      firstNameInvite: "",
      lastNameInvite: "",
      emailInvite: "",
      invitePhoneNumber: '',
      inviteStatus: "",
      countryInvite: "default",
      languageInvite: "default",
      typeInvite: "default",
      target: [],
      lastEditedBy: "-",
      statusEdit: "",
      error: false,
      inviteErrorText: "",
      viewImage: require('@/assets/Vector.png').default,
      editImage: require('@/assets/editing.png').default,
      deleteImage: require('@/assets/Group.svg').default,
      requiredError: false,
      searchFilter: "default",
      emailSearch: "",
      emailFilter: false,
      phoneFilter: false,
      closeImage: require('@/assets/close.png').default,
      findModal: false,
      emailSearchError: false,
      firstNameError: false,
      lastNameError: false,
      invitePhoneError: false,
      typeInviteError: false,
      languageInviteError: false,
      countryInviteError: false,
      emailError:false
    };
  },

  components: {
    Alert,
  },

  computed: {
    isSuperadmin() {
      return this.$store.state.currentUser.user.type === "superadmin";
    },
  },

  methods: {
    initDataTable() {
      let self = this;
      setTimeout(function () {
        $.fn.dataTableExt.sErrMode = 'throw';
        var table = $(".zero-configuration").DataTable({
          bLengthChange: false,
          bFilter: false,
          order: [],
        });
        table.on('responsive-resize', function (e, datatable, columns) {
          let count = columns.reduce(function (a, b) {
            return b === false ? a + 1 : a;
          }, 0);
          console.log(count + ' column(s) are hidden');
        })
      }, 100);
    },
    emailSearchValidation() {
      let self = this;
      if (this.$filters.validateEmail(self.emailSearch)) {
        self.emailError = false;
      } else {
        self.emailError = true;
      }
    },
    findByEmailModal() {
      if (this.searchFilter == "all") {
        let self = this;
        self.emailSearch = ''
        self.findByEmail()
        self.getAdmins()
      } else {
        self.findModal = true;
        if (self.findModal) {
          $("#find-by-email-modal").modal()
        }
      }

    },
    firstnameValidate() {
      let self = this;
      if (self.firstNameInvite) {
        self.firstNameError = false;
      } else {
        self.firstNameError = true;
      }
    },
    lastnameValidate() {
      let self = this;
      if (self.lastNameInvite) {
        self.lastNameError = false;
      } else {
        self.lastNameError = true;
      }
    },
    emailValidation() {
      let self = this;
      if (this.$filters.validateEmail(self.emailInvite)) {
        self.emailSearchError = false;
      } else {
        self.emailSearchError = true;
      }
    },
    languageValidate() {
      let self = this;
      if (self.languageInvite != 'default') {
        self.languageInviteError = false;
      } else {
        self.languageInviteError = true;
      }
    },

    closeModal() {
      $("#find-by-email-modal").modal("hide");
      let self = this;
      console.log("dropppp")
      self.searchFilter = 'default';
      self.emailSearch = '';
      self.emailError = false;
    },
    findByPhoneModal() {
      $("#find-by-phone-modal").modal()
    },
    inviteModalClose() {
      this.firstNameInvite = "";
      this.lastNameInvite = "";
      this.emailInvite = "";
      this.invitePhoneNumber = "";
      this.typeInvite = "default";
      this.languageInvite = "default";
      this.countryInvite = "default"
      this.emailSearchError = false;
      this.requiredError = false;
      this.firstNameError = false;
      this.lastNameError = false;
      this.invitePhoneError = false;
      this.typeInviteError = false;
      this.languageInviteError = false;
      this.countryInviteError = false;
    },
    findByEmail() {
      let self = this
      self.admins = []
      self.loadingData = true
      self.emailFilter = true
      $("find-by-email-modal").modal('hide')
      this.$apiCall.get(`v1/admins/email/${self.emailSearch}`)
        .then(response => {

          self.admins.push(response.data)
          self.emailSearch = ''
          self.searchFilter = 'default'
          self.findModal = false;
          self.loadingData = false
          self.initDataTable()
        })
        .catch(error => {
          self.emailSearch = ''
          self.loadingData = false
          self.initDataTable()
        })
    },
    findByPhone() {
      let self = this
      self.admins = []
      self.loadingData = true
      self.phoneFilter = true
      let countryData = this.phoneNumberObj.getSelectedCountryData()
      let pN = '%2B' + countryData.dialCode + this.invitePhoneNumber.replace(`+${countryData.dialCode}`, "")
      console.log("code", pN)
      $("find-by-email-modal").modal('hide')
      this.$apiCall.get(`v1/admins/phone/${pN}`)
        .then(response => {

          self.admins.push(response.data)

          self.phoneSearch = ''
          self.loadingData = false
          self.initDataTable()
        })
        .catch(error => {
          self.emailSearch = ''
          self.loadingData = false
          self.initDataTable()
        })
    },



    initTelInput() {
      let input = document.querySelector("#phoneNumber");
      this.phoneNumberObj = intlTelInput(input);
      console.log("phoneeeeeeeee", this.phoneNumberObj)
    },


    searchInTable() {
      let self = this;
      self.loadingData = true;
      var searchValue = this.searchInputText.toLowerCase()
      self.admins = [];
      self.$apiCall
        .get(`/v1/admins?name=${searchValue}`)
        .then((response) => {
          self.loadingData = false;
          self.admins = response.data.data;
          self.initDataTable();
        });

    },

    getAdmins() {
      let self = this;
      self.emailFilter = false;
      self.phoneFilter = false;
      self.loadingData = true;
      this.$apiCall.get("/v1/admins").then((response) => {
        self.loadingData = false;
        self.admins = response.data.data;
        console.log("usersssssss", self.admins)
        response.data.data.forEach(function (element) {
          if (
            !self.usersCountries.includes(element.country) &&
            element.country
          ) {
            self.usersCountries.push(element.country);
          }
        });
        self.initDataTable();
      });
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    langName(element) {
      if (element) {
        return getLanguageName(element);
      }
    },

    filterByCountry(country) {
      let self = this;
      if (country != "Select Country") {
        self.loadingData = true;
        self.admins = [];
        self.$apiCall
          .get(`/v1/admins?country=${country}`)
          .then((response) => {
            self.loadingData = false;
            self.admins = response.data.data;
            self.initDataTable();
          });
      } else {
        self.admins = [];
        self.usersCountries = [];
        self.getAdmins();
      }
    },

    filterByStatus(status) {
      let self = this;
      if (status != "Select Status") {
        self.loadingData = true;
        self.admins = [];
        self.$apiCall
          .get(`/v1/admins?status=${status}`)
          .then((response) => {
            self.loadingData = false;
            self.admins = response.data.data;
            self.initDataTable();
          });
      } else {
        self.admins = [];
        self.usersCountries = [];
        self.getAdmins();
      }
    },

    getActiveCountries() {
      const countries = localStorage.getItem('activeCountries');
      this.activeCountries = (countries && countries != '') ? countries.split(',') : ["LB", "JO"];
    },

    editAdminModal(uid) {
      console.log("aaaaaaaaaaaaaaaaaaaaaaaa", uid)
      this.$router.push({ name: 'EditUserPage', params: { uid: uid } });
    },

    editAdmin(uid) {
      let self = this;
      let block_ele = $("#edit-admin-modal .modal-content");
      $(block_ele).block({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      if (self.statusEdit != self.target.status) {
        if (self.statusEdit == "joined") {
          self.$apiCall.post(`/v1/users/${uid}/unban`).then((response) => {
            $(block_ele).unblock();
            self.admins = [];
            self.getAdmins();
            $("#edit-admin-modal").modal("hide");
          });
        } else {
          self.$apiCall.post(`/v1/users/${uid}/ban`).then((response) => {
            $(block_ele).unblock();
            self.admins = [];
            self.getAdmins();
            $("#edit-admin-modal").modal("hide");
          });
        }
      }
    },

    inviteAdminModal() {
      this.inviteErrorText = ''
      this.error = false;
      $("#invite-admin-modal").modal();
    },
    sucessAdminModal() {
      this.inviteErrorText = ''
      this.error = false;
      $("#invite-success-modal").modal();
    },
    requiredErrorCheck() {
      let self = this;
      if (self.firstNameInvite && self.lastNameInvite && self.emailInvite && self.invitePhoneNumber && self.typeInvite != 'default' && self.languageInvite != 'default'
        && self.countryInvite != 'default') {
        self.requiredError = false;
      } else {
        self.requiredError = true;
      }
    },
    phoneNumberValidate() {
      let self = this;
      if (self.invitePhoneNumber) {
        self.requiredError = false;
        if (/^\d{10}$/.test(self.invitePhoneNumber)) {
          self.invitePhoneError = false;
        } else {
          self.invitePhoneError = true;
        }
      } else {
        self.requiredError = true;
      }
    },
    typeValidate() {
      let self = this;
      if (self.typeInvite != 'default') {
        self.typeInviteError = false;
      } else {
        self.typeInviteError = true;
      }
    },
    sendInvitation() {
      console.log("clickkkkkkkk")
      let self = this;
      self.requiredErrorCheck()
      if (!self.requiredError) {
        self.firstnameValidate()
        self.lastnameValidate()
        self.emailValidation()
        self.phoneNumberValidate()
        self.typeValidate()
        self.languageValidate()
        self.countryValidate()
      }
      if (!self.requiredError && !self.emailSearchError) {
        self.error = false;
        let countryData = this.phoneNumberObj.getSelectedCountryData();
        let pN = "+" + countryData.dialCode + self.invitePhoneNumber.replace(`+${countryData.dialCode}`, "");
        var block_ele = $("#invite-admin-modal .modal-content");
        $(block_ele).block({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait",
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent",
          },
        });
        this.$apiCall
          .post("/v1/admins/invite", {
            email: (self.emailInvite.trim() != "") ? self.emailInvite.trim() : null,
            firstName: self.firstNameInvite,
            lastName: self.lastNameInvite,
            phoneNumber: (self.invitePhoneNumber != "") ? pN : null,
            language: self.languageInvite,
            type: self.typeInvite,
            country: self.countryInvite,
          })
          .then((response) => {
            $(block_ele).unblock();
            self.invitePhoneNumber = "";
            self.firstNameInvite = "";
            self.lastNameInvite = "";
            self.emailInvite = "";
            if (self.$store.state.currentUser.user.type == "superadmin") {
              self.countryInvite = "lb";
            } else {
              self.countryInvite = self.$store.state.currentUser.user.country;
            }
            self.languageInvite = "en";
            self.typeInvite = "admin";
            $("#invite-admin-modal").modal("hide");
            this.sucessAdminModal()
            self.admins = [];
            self.getAdmins();
          })
          .catch((error) => {
            $(block_ele).unblock();
            self.inviteErrorText =
              error.response.status == 406 | 405
                ? "Ops! These invitation data <strong>already exist</strong>"
                : `<strong>Ops!</strong> ${error.response.data.message}`;
          });

      }
    },
    countryValidate() {
      let self = this;
      if (self.countryInvite != 'default') {
        self.countryInviteError = false;
      } else {
        self.countryInviteError = true;
      }
    },

    deleteInvitation(uid) {
      let self = this;
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall.delete(`/v1/admins/invite/${uid}`).then((response) => {
        $.unblockUI();
        self.admins = [];
        self.getAdmins();
      });
    },
  },

  watch: {
    invitePhoneNumber: function (value) {
      this.invitePhoneNumber = value.replace(/[^\d|\-+]/g, '')
    },
    phoneSearch: function (value) {
      this.phoneSearch = value.replace(/[^\d|\-+]/g, '')
    },
  },

  mounted() {
    this.initTelInput();
    this.getAdmins();
    this.getActiveCountries();
  },
};
</script>

<style scoped>
.zero-configuration td {
  white-space: nowrap;
}

.btn-primary {
  background-color: #4A0A1E !important;
}

.iconStyle {
  width: 22px;
}

.iconEditStyle {
  height: 15px;
  width: 16px;
}

.modalStyle {
  width: 635px;
  margin-left: 10em;
  margin-top: 5em;
}

@media (min-width: 768px) and (max-width: 1280px) {
  .modalStyle {
    width: 752px;
    margin-left: 8em;
    margin-top: 12em;
  }
}

.searchInput {
  height: 3.5em;
}

.modalFooter {
  border-top: 1px solid #DFE3E7;
}

.alignFix {
  margin-top: -2em;
}

.alignmentFix {
  padding-left: 4em;
}

.elipss {
  overflow: hidden;
  white-space: nowrap;
  width: 70%;
  text-overflow: ellipsis;
}

.listSize {
  padding-right: 14px;
}

.modalPopStyle {
  margin-left: 44em;
  margin-top: 182px;
}

.divStyleModall {
  margin-left: 3em;
  margin-top: 29px;
}

.resetPasswordHeading {
  color: #4A0A1E;
  font-size: 18px !important;
  font-weight: 450 !important;
  margin-left: -13px;
}

.resetPasswordDialogue {
  height: 19em;
  border-radius: 1rem !important;
  margin-top: 33%;
}

@media (max-width: 1366px) {
  .resetPasswordDialogue {
    height: 19em;
    border-radius: 1rem !important;
    margin-top: 38%;
    margin-left: -248px;
  }

}
</style>
